import axios from 'axios'
import router from '@/router'
import Vue from 'vue'

const requests = axios.create({
  // baseURL: 'http://192.168.10.7',

  // baseURL: 'https://sxx.sxlawyer.net/',
  // baseURL: 'https://sxx.sxlawyer.net/',
  baseURL: 'http://lsh.beishancloud.com/',
  // baseURL: 'https://sxx.sxlawyer.net/',

  timeout: 5000
})

// 添加请求拦截器
requests.interceptors.request.use(
  function (config) {
    // 在发送请求之前做些什么
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = token
    }
    return config
  },
  function (error) {
    // 对请求错误做些什么
    return Promise.reject(error)
  }
)

// 添加响应拦截器
requests.interceptors.response.use(
  function (response) {
    // 2xx 范围内的状态码都会触发该函数。
    // 对响应数据做点什么
    console.log(response);
    if (response.data.code == 401 || response.data.msg == 'user is error' && router.currentRoute.path !== '/login') {
      console.log(123);
      localStorage.removeItem('token');
      localStorage.removeItem('vuex');
      // Vue.prototype.$message({
      //   showClose: true,
      //   message: '登录信息有误，请重新登录',
      //   type: 'error'
      // })
      router.push('/login')
    } else if (response.data.code != 200) {
      Vue.prototype.$message({
        showClose: true,
        message: response.data.msg,
        type: 'error'
      })
    }
    return response
  },
  function (error) {
    // 超出 2xx 范围的状态码都会触发该函数。
    // 对响应错误做点什么
    // 检查响应错误的状态码


    return Promise.reject(error)
  }
)

export default requests
